export default ['bindemail', 'bindphone']
